import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable import/no-cycle */
import React from "react";
import { useHistory } from "react-router-dom";
import styles from "./styles.module.css";
function CheckoutProgressbar(props) {
    const history = useHistory();
    const { active, pages } = props;
    // go to next page
    const goCheckout = (index) => {
        // if validation is not passed, abort next step
        if (props.nextDisabled && index === active + 1)
            return;
        if (active >= index - 1 && active !== index) {
            props.onGoNext && props.onGoNext();
            history.push(pages[index]);
        }
    };
    return (_jsx("div", { className: styles.checkoutprogress, children: pages &&
            pages.length > 0 &&
            pages.map((item, index) => (_jsx("button", { type: "button", className: `${styles.progressitem} ${active >= index - 1 ? styles.clickable : ""} ${index !== pages.length - 1 && styles.progressitemmid}  ${index === active && styles.progressitemactive}`, onClick: () => {
                    goCheckout(index);
                }, children: index + 1 }, item))) }));
}
export default CheckoutProgressbar;
